import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import ProfileTab from "../../../core/common/profiletab";
import Swal from "sweetalert2";
import useApi from "../../../core/customhook/useApi";

const SubmitDetails = () => {
  const [callAgain, setCallAgain] = useState(0)
  const routes = all_routes;
  const {
    data: onboardingstatus,
    loading: onboardingstatusLoading,
    error: onboardingstatusError,
  } = useApi("/api/onboarding/final-status", {
    method: "GET",
    autoCall: true,
    dependencies: [callAgain]
  });

  const status = onboardingstatus?.data?.onb_status;
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Two API hooks (POST)
  const { callApi: checkBeforeSubmit } = useApi("/api/onboarding/check-onboarding-details", {
    method: "POST",
    autoCall: false
  });

  const { callApi: submitOnboarding } = useApi("/api/onboarding/final-submission", {
    method: "POST",
    autoCall: false
  });

 const handleSubmit = async () => {
  if (!isConfirmed) return;
  setIsSubmitting(true);

  try {
    // 🔹 Step 1: Check if all details are filled before submission
    const checkResponse = await checkBeforeSubmit();
    if (!checkResponse?.success) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Details",
        text:
          checkResponse?.message ||
          "Please complete all required sections before submitting.",
        confirmButtonText: "OK",
      });
      setIsSubmitting(false);
      return;
    }

    // 🔹 Step 2: Ask for final confirmation before submission
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once submitted, you will not be able to edit these details!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      setIsSubmitting(false);
      return; // user canceled
    }

    // 🔹 Step 3: If confirmed, submit onboarding
    const submitResponse = await submitOnboarding();

    if (submitResponse?.success) {
      Swal.fire({
        icon: "success",
        title: "Submitted!",
        text:
          submitResponse?.message ||
          "Your onboarding details have been successfully submitted.",
        confirmButtonText: "OK",
      });
      setCallAgain(callAgain + 1);
    } else {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text:
          submitResponse?.message ||
          "Your onboarding submission failed. Please try again later.",
        confirmButtonText: "OK",
      });
    }
  } catch (error: any) {
    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Incomplete Form",
      text:
        error?.response?.data?.message ||
        "Please fill out all required fields before submitting.",
      confirmButtonColor: "#d33",
    });
  } finally {
    setIsSubmitting(false);
  }
};


  console.log(status)

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Final Submission</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Onboarding</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Submit Details
                </li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 theiaStickySidebar">
            <div
              className="stickybar"
              style={{ position: "sticky", top: "50px" }}
            >
              <ProfileTab />
            </div>
          </div>

          {status === "Submited" || status === "Approved" ? (
            <div className="col-xl-9">
              <div className="card">
                <div className="card-body text-center">
                  <h4 className="mb-3 text-success">Onboarding Already {status}</h4>
                  <p className="text-muted">
                    Your onboarding details have already been submitted successfully.
                    Please wait for administrator approval.
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-xl-9">
              <div className="card">
                <div className="card-body">
                  <h4 className="mb-3">Review and Submit</h4>
                  <p className="text-muted">
                    Please ensure all your personal and professional details have
                    been filled in correctly. Once submitted, you won't be able to
                    make changes unless approved by an administrator.
                  </p>

                  <div className="form-check mt-4 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="confirmCheck"
                      checked={isConfirmed}
                      onChange={(e) => setIsConfirmed(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="confirmCheck">
                      I confirm that the information provided is true and accurate
                      to the best of my knowledge.
                    </label>
                  </div>

                  <button
                    className="btn btn-primary custom_button"
                    disabled={!isConfirmed || isSubmitting}
                    onClick={handleSubmit}
                  >
                    {isSubmitting ? "Submitting..." : "Submit Details"}
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>

      <div className="footer d-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default SubmitDetails;
